import { Translations } from "../types";

/**
 * Japanese Translations (日本語)
 * Placeholder - to be completed by native speaker
 */
export const ja: Translations = {
  common: {
    continue: "続ける",
    retry: "再試行",
    ignore: "無視",
    loading: "読み込み中...",
    select: "選択",
    error: "エラー",
    success: "成功",
    cancel: "キャンセル",
    confirm: "確認",
    back: "戻る",
    close: "閉じる",
    save: "保存",
    delete: "削除",
    edit: "編集",
    new: "新規",
    yes: "はい",
    no: "いいえ",
    or: "または",
    and: "と",
    show: "表示",
    hide: "非表示",
    advanced: "詳細",
    enabled: "有効",
    disabled: "無効",
  },

  menu: {
    profile: "プロフィール",
    play: "プレイ",
    playAgain: "もう一度プレイ",
    shop: "ショップ",
    options: "設定",
    credits: "クレジット",
    referral: "招待",
    labs: "ラボ",
    dailyRewards: "報酬",
    battlePass: "バトルパス",
    creators: "クリエイター",
    marketplace: "マーケット",
    social: "ソーシャル",
    clan: "クラン",
    replays: "リプレイ",
    chooseMode: "🎮 モード選択",
    selectHowToPlay: "プレイ方法を選択",
    playSolo: "ソロプレイ",
    playSoloDesc: "AIとの無限バトル",
    storyMode: "ストーリーモード",
    storyModeDesc: "アーサー・レンの物語",
    multiplayer: "マルチプレイ",
    multiplayerDesc: "ルームを作成または参加",
    tournaments: "トーナメント",
    tournamentsDesc: "賞品付き大会",
    ranking: "ランキング",
    rankingDesc: "グローバル順位を確認",
    experimental: "ラボ",
    experimentalDesc: "実験的機能",
    competitive: "競技モード",
    competitiveDesc: "ランキング・トーナメント・リーダーボード",
    infiniteBattle: "無限バトル",
    infiniteBattleDesc: "終わりなきウェーブ。限界まで生き延びろ！",
    battleRoyaleDesc: "最大300台。最後の1台が勝者！",
    genAIMode: "GenAIモード",
    genAIModeDesc: "生成AIと対戦・観戦",
    tagRoguelike: "ローグライク",
    tagTerrains: "6種の地形",
    tagElectricBarrier: "電撃バリア",
    tagUniqueItems: "6種の専用アイテム",
    tagHot: "人気",
    tagNew: "新着",
    tagSkins: "スキン",
  },

  profile: {
    personalData: "個人情報",
    birthDate: "生年月日（任意）",
    showFullIdHint: "クリックで完全なIDを表示・非表示",
    copyId: "IDをコピー",
    copy: "コピー",
    crossSaveTitle: "クロスセーブ:",
    crossSaveDesc: "GoogleまたはDiscordアカウントを連携すると、進行状況が端末間（ウェブ・モバイル・デスクトップ）で自動的に同期されます。",
    uniqueIdTitle: "固有ID",
    odysIdLabel: "Odys ID（サポート用）",
    odysIdHint: "このIDは固有で変更されません。サポートへの問い合わせ時にお使いください。",
    session: "セッション",
    switchAccount: "アカウント切り替え / ログアウト",
    switchAccountHint: "ログアウトしてログイン画面に戻ります。",
    avatarGallery: "アバターギャラリー",
    avatarGalleryDesc: "ストーリーモードの章をクリアして新しいアバターを解放しよう",
    avatarsUnlocked: "解放済み",
  },

  matchSetup: {
    configureMatch: "マッチ設定",
    selectOpponents: "対戦相手の数を選択",
    tanksInArena: "台がアリーナに参加",
    arenaSize: "アリーナサイズ",
    arenaSizeDesc: "縮小する電撃バリア",
    units: "ユニット",
    blocks: "ブロック",
    blocksDesc: "破壊可能な障害物の密度",
    blocksEstimate: "約{count}ブロック",
    perfLimited: "（パフォーマンスにより制限）",
    densityNone: "なし",
    densityFew: "少なめ",
    densityMany: "多め",
    environment: "環境",
    environmentDesc: "バトルの舞台を選択",
    availableItems: "使用可能アイテム",
    powerUpsCount: "（パワーアップ{count}種）",
    itemsHint: "バトル中、アリーナにランダムでパワーアップが出現します。拾って一時的な強化を手に入れよう！",
  },

  shop: {
    title: "✨ ショップ",
    subtitle: "戦車をカスタマイズ！",
    tabs: {
      mystery: "ボックス",
      skins: "スキン",
      effects: "エフェクト",
      crystals: "クリスタル",
      tanks: "戦車",
    },
    rarity: {
      all: "すべて",
      common: "コモン",
      rare: "レア",
      epic: "エピック",
      legendary: "レジェンダリー",
    },
    // Mystery Boxes
    mysteryBoxes: "ミステリーボックス",
    mysteryBoxesDesc: "ボックスを開けてランダムな戦車をゲット！",
    mysteryBox: {
      common: "コモンボックス",
      rare: "レアボックス",
      epic: "エピックボックス",
      legendary: "レジェンダリーボックス",
    },
    mysteryBoxTip: "💡 ヒント：ボックスのレアリティが高いほど、エピックやレジェンダリー戦車の確率が上がります！",
    // Crystals
    crystalPackages: "クリスタルパッケージ",
    crystalPremiumDesc: "クリスタルはプレミアムアイテムの購入に使用されます",
    bonusAmount: "+{bonus} ボーナス！",
    redirectingPayment: "決済画面に移動中...",
    securePaymentInfo: "Stripeで安全に処理されます。クリスタルは即座に追加されます。",
    // Tanks
    tanks: "戦車",
    tanksUnlocked: "{unlocked}/{total} アンロック済み",
    tanksFound: "{count} 戦車が見つかりました",
    free: "無料",
    // Filters
    filters: "フィルター",
    filterRarity: "レアリティ",
    filterSize: "サイズ",
    filterShots: "発射数",
    sizeAll: "すべて",
    sizeMini: "ミニ",
    sizeNormal: "ノーマル",
    sizeLarge: "ラージ",
    sizeTitan: "タイタン",
    shotSingle: "シングル",
    shotDouble: "ダブル",
    shotTriple: "トリプル",
    // Skins
    skins: "スキン",
    skinsDesc: "戦車の外観をカスタマイズ",
    equip: "装備",
    equippedLabel: "装備中",
    // Effects
    effects: "エフェクト",
    effectsDesc: "ユニークなビジュアルエフェクトを追加",
    effectTypes: {
      trail: "軌跡",
      explosion: "爆発",
      shot: "発射",
      aura: "オーラ",
      movement: "移動",
      special: "スペシャル",
    },
    // Purchase modal
    tank: "戦車",
    skin: "スキン",
    effect: "エフェクト",
    cancel: "キャンセル",
    tankSkins: "戦車スキン",
    tankSkinsDesc: "ソロとマルチで外観を変更",
    skinsCount: "{count} スキン",
    visualEffects: "ビジュアルエフェクト",
    visualEffectsDesc: "軌跡、爆発、オーラ！",
    effectsCount: "{count} エフェクト",
    crystalDescription: "限定アイテムをアンロック！",
    popular: "人気",
    bonus: "+{percent}%",
    crystals: "クリスタル",
    securePayment: "Stripeで安全な支払い",
    paymentNotConfigured: "支払いが設定されていません",
    confirmPurchase: "購入確認",
    price: "価格",
    yourBalance: "残高",
    insufficientBalance: "⚠️ 残高不足",
    buy: "購入",
    noBalance: "残高なし",
    use: "使用",
    active: "✓ 装備中",
    equipped: "装備しました！",
    removed: "解除しました",
    unlocked: "🎉 「{name}」をアンロック！",
    chipsInsufficient: "🪙 チップが足りません！",
    crystalsInsufficient: "💎 クリスタルが足りません！",
    chipsInfo: "💡 サブスクでクリスタル獲得！チップ: 基本10 + キル5 + 勝利20",
    paymentCancelled: "支払いがキャンセルされました",
    crystalsAdded: "🎉 +{amount} クリスタル追加！",
    paymentUnavailable: "決済システムが利用できません",
    openingCheckout: "チェックアウトを開いています...",
    effectRemoved: "エフェクト解除",
    generateNewCode: "新しいコードを生成",
    converted: "変換完了！",
  },

  ads: {
    watchForBonus: "広告を見る → ボーナスチップ",
  },
  labs: {
    hardcoreMode: "ハードコアモード",
    title: "🔬 ラボ",
    subtitle: "実験的機能と新機能",
    arMode: "拡張現実",
    arModeDesc: "カメラを使ってテーブルでRocketanksをプレイ！",
    battleRoyale: "バトルロイヤル",
    battleRoyaleDesc: "50台の戦車、勝者は1人。縮小する電気アリーナ！",
    vrMode: "VRモード",
    vrModeDesc: "近日公開...",
    advancedAI: "高度なAI",
    advancedAIDesc: "近日公開...",
    openWorld: "オープンワールド",
    openWorldDesc: "近日公開...",
    comingSoon: "近日公開...",
    experimentalWarning: "💡 ラボ機能は実験的で、変更または削除される可能性があります。フィードバックをお待ちしています！",
    beta: "ベータ",
  },

  ar: {
    checking: "ARサポートを確認中...",
    unavailable: "AR利用不可",
    unavailableReason: "お使いのデバイスは拡張現実をサポートしていません",
    tip: "💡 ヒント:",
    tipDevices: [
      "Android + Chrome",
      "iOS + Safari（WebAR SDK またはカメラ）",
      "HTTPS接続",
    ],
    startAR: "🚀 AR開始",
    startCamera: "カメラ開始",
    loading: "読み込み中...",
    exit: "終了",
    instructions: "👆 タップで移動 • 🔄 ドラッグでカメラ回転",
    permission: "ARモード",
    permissionTitle: "ARモード",
    permissionDesc: "平らな面にカメラを向けて、拡張現実で戦車バトルを見よう！",
    cameraAccess: "背面カメラへのアクセス",
    touchToMove: "タッチで移動と射撃",
    rotateCamera: "カメラを回転して周りを見る",
    // 新しいWebXR翻訳
    title: "ARモード",
    notSupported: "AR利用不可",
    howItWorks: "使い方:",
    step1: "平らな面（テーブル、床）にカメラを向ける",
    step2: "レティクルが表示されたらタップでボードを配置",
    step3: "ジョイスティックと発射ボタンでプレイ！",
    placeBoard: "ボードを配置",
    placeInstructions: "平らな面にレティクルが表示されるまで携帯を動かし、タップして配置",
    webARStep1: "高度な WebAR 体験を開始（8th Wall/Zappar）",
    webARStep2: "実環境に向けて、画面の案内に従ってください",
    // カメラフォールバックモード
    cameraStep1: "デバイスのカメラアクセスを許可",
    cameraStep2: "ボードがカメラ上に表示されます",
    modeWebXR: "表面検出付きARモード",
    modeWebARSDK: "高度なWebARモード（クロスプラットフォーム）",
    modeCamera: "シミュレートカメラモード",
    tryCamera: "カメラモードを試す",
    openExternal: "外部で開く",
    // サポートされているデバイスリスト
    deviceAndroid: "Android（Chromeブラウザ）",
    deviceIOS: "iPhone/iPad（Safariブラウザ）",
    deviceQuest: "Oculus Questブラウザ",
    // RocketAR Engine — モード選択
    selectEngine: "ARエンジンを選択",
    selectEngineDesc: "お使いのデバイスに最適なモードを選択してください",
    recommendedBadge: "おすすめ",
    unavailableBadge: "利用不可",
    selectMode: "選択",
    backToSelection: "AR選択に戻る",
    modeARCore: "ARCore ネイティブ",
    descWebXR: "表面検出、ヒットテスト、実世界アンカリング付きの完全なAR",
    descARCore: "最高のパフォーマンスと精密なトラッキングのネイティブAndroid AR",
    descWebARSDK: "8th Wall/ZapparによるクロスプラットフォームWebAR、iOSとAndroidで動作",
    descCamera: "3Dゲームボードオーバーレイ付きのシンプルカメラ、どのデバイスでも動作",
    reasonNoNative: "ネイティブAndroidアプリでのみ利用可能",
    reasonNoWebXR: "このブラウザはWebXR ARをサポートしていません",
    reasonNoSDK: "このバージョンではWebAR SDKが設定されていません",
    reasonNoCamera: "このデバイスではカメラが検出されませんでした",
  },

  game: {
    wave: "ウェーブ",
    lives: "ライフ",
    score: "スコア",
    kills: "キル",
    pause: "一時停止",
    resume: "再開",
    quit: "終了",
    victory: "勝利！",
    defeat: "敗北",
    nextWave: "次のウェーブ",
    waveComplete: "ウェーブクリア！",
    enemiesDefeated: "倒した敵",
    bonus: "ボーナス",
    total: "合計",
    gameOver: "ゲームオーバー",
    finalScore: "最終スコア",
    play: "プレイ",
    playAgain: "もう一度プレイ",
    playSubtitle: "ソロ • ストーリー • マルチプレイ • トーナメント • ランキング",
    // GameUI
    armor: "装甲",
    targets: "ターゲット",
    points: "ポイント",
    radar: "レーダー",
    item: "アイテム",
    charge: "チャージ",
    nominal: "正常",
    alert: "警告",
    critical: "危険",
    powerUp: "パワー+",
    cryo: "クライオ",
    shield: "シールド",
    turbo: "ターボ",
    controls: "WASD: 移動 | スペース: 発射",
    controlsDesc: "ゲームコントロール",
    forward: "W - 前進",
    reverse: "S - 後退",
    left: "A - 左",
    right: "D - 右",
    clickToAim: "クリックでマウス照準",
    speed: "速度",
    equipment: "装備",
    empty: "なし",
    heading: "方位",
    cameraToggle: "カメラ (C)",
    // WaveComplete
    waveCompleteTitle: "ウェーブ{wave}クリア！",
    finalVictory: "勝利！",
    enemiesEliminated: "撃破した敵",
    pointsLabel: "スコア",
    remainingLife: "残りライフ",
    reward: "報酬",
    nextWaveLabel: "次のウェーブ",
    continueBtn: "続ける →",
    restartFromBeginning: "最初からやり直す",
    hpRestored: "+30 HPがウェーブ間で回復",
    backToMenu: "メニューに戻る",
    // ウェーブ難易度
    difficultyEasy: "簡単",
    difficultyMedium: "普通",
    difficultyHard: "難しい",
    difficultyVeryHard: "とても難しい",
    difficultyExtreme: "極限",
    difficultyInsane: "狂気",
    difficultyImpossible: "不可能",
    // PauseOverlay
    gamePaused: "一時停止中",
    storyPaused: "ストーリー一時停止中",
    youPaused: "ゲームを一時停止しました",
    playerPaused: "{name}がゲームを一時停止しました",
    anotherPlayerPaused: "他のプレイヤーが一時停止",
    tapToContinue: "タップして続ける",
    gamepadPauseHint: "Aで再開 • BまたはStartで戻る",
    restart: "リスタート",
    restartCurrentRoom: "現在の部屋を再開",
    pauseControls: "ESCまたはPで一時停止/再開",
    confirmQuit: "もう一度タップで終了",
    confirmRestart: "もう一度タップで再開始",
    retryRun: "もう一度",
    retryRunDesc: "同じ戦車で新しいラン",
    changeMode: "モードや戦車を変える",
  },

  tank: {
    equipped: "装備中",
    chooseTank: "戦車を選択",
    roguelikeMode: "ローグライクモード - 5ウェーブごとに地形が変化",
    speed: "速度",
    damage: "ダメージ",
    health: "体力",
    unlocked: "アンロック済み",
    locked: "ロック中",
    startBattle: "バトル開始！",
    family: "系譜",
    familyPredator: "プレデター",
    familyColossus: "コロッサス",
    familyVenom: "ヴェノム",
    familyStorm: "ストーム",
    familyPhantom: "ファントム",
    familyBulwark: "バルワーク",
    familyCosmic: "コズミック",
    familyMythic: "ミシック",
    familyDescPredator: "全速力で獲物を追う俊足の斥候",
    familyDescColossus: "重装甲を誇る鈍重な要塞",
    familyDescVenom: "絶え間ない精密な圧をかける狩人",
    familyDescStorm: "圧倒的な長距離砲撃",
    familyDescPhantom: "敵レーダーから消える潜入者",
    familyDescBulwark: "生きた防御を持つ宝石装甲",
    familyDescCosmic: "軌道制御と星の精密さ",
    familyDescMythic: "固有の力を宿す生ける伝説",
    special: "パワー",
    specialElite: "強化されたエリートパワー",
    specialShield: "リアクティブアーマー",
    specialStealth: "アクティブ迷彩",
    specialRegen: "リジェネレーション",
    specialExplosive: "爆発弾",
    specialPiercing: "貫通弾",
    specialHoming: "ホーミング弾",
    specialRebirth: "フェニックスの再生",
    specialBurn: "ドラゴンブレス",
    specialDescShield: "受けるダメージをすべて軽減",
    specialDescStealth: "数秒間撃たずにいると、遠くの敵のレーダーから消える",
    specialDescRegen: "数秒間ダメージを受けないと装甲が回復",
    specialDescExplosive: "着弾時に周囲へ範囲ダメージ",
    specialDescPiercing: "弾が敵を貫通して直進",
    specialDescHoming: "弾が最も近い敵へ軌道修正",
    specialDescRebirth: "撃破されても一度だけ灰の中から装甲の一部とともに蘇る",
    specialDescBurn: "弾が命中した敵を炎上させ、継続ダメージを与える",
    mastery: "マスタリー",
    masteryProgress: "{kills} キル — 次のレベルまで {next}",
    masteryMax: "マスタリー最大 — {kills} キル",
    speedShort: "速度",
    damageShort: "攻撃",
    healthShort: "耐久",
    selected: "選択中",
    select: "選択する",
    tapToView: "タップして表示",
    dragToRotate: "ドラッグで3D回転",
    availableToBuy: "🔒 入手可能（{count}）",
    skinLabel: "🎨 スキン: {name}",
    defaultSkin: "デフォルト",
    activeSkinSolo: "適用中のスキン（ソロ）",
    noSkin: "スキンなし（デフォルト）",
    unequipSkin: "スキンを外す",
    activeEffectSolo: "適用中のエフェクト（ソロ）",
    noEffect: "エフェクトなし",
    unequipEffect: "エフェクトを外す",
    skinIncompatible: "装備中のスキン「{skin}」は{tank}に対応していません。プレビューではデフォルトの外観を表示しています。",
  },

  multiplayer: {
    stepRoom: "ルーム",
    stepArena: "アリーナ",
    stepWait: "待機",
    stepOf: "ステップ {n}/{total}",
    createRoomDesc: "アリーナを選んで友達を招待",
    joinRoomDesc: "友達から届いたコードを入力",
    addBot: "+1 ボット",
    copyCode: "コピー",
    createRoom: "ルーム作成",
    joinRoom: "ルーム参加",
    join: "参加",
    roomCode: "ルームコード",
    enterCode: "コードを入力",
    waiting: "プレイヤーを待機中...",
    playersReady: "{count}/{total} プレイヤー準備完了",
    startGame: "ゲーム開始",
    leave: "退出",
    copied: "コピーしました！",
    shareCode: "コードを友達と共有",
    // Lobby
    title: "マルチプレイヤー",
    subtitle: "友達と一緒にプレイ",
    victoryTitle: "🏆 勝利！",
    defeatTitle: "💀 敗北",
    playAgain: "もう一度プレイ",
    winner: "勝者",
    exit: "← 終了",
    shareWhatsApp: "WhatsAppで共有",
    selectedArena: "選択したアリーナ",
    yourTank: "あなたの戦車",
    yourColor: "あなたの色",
    playersCount: "プレイヤー ({count}/4)",
    you: "(あなた)",
    host: "ホスト",
    gameMode: "ゲームモード",
    elimination: "エリミネーション",
    eliminationDesc: "最後の1人",
    deathmatch: "デスマッチ",
    deathmatchDesc: "キルで勝利",
    timeLimit: "タイム",
    timeLimitDesc: "時間内の最多キル",
    livesMode: "ライフ",
    livesModeDesc: "限定ライフ",
    battleRoyale: "バトルロイヤル",
    battleRoyaleDesc: "縮小ゾーン、最後の1人が勝利",
    battleRoyaleHint: "電気ゾーンは段階的に縮小し、外にいるプレイヤーに増加するダメージを与えます。リスポーンなし：最後まで生き残った戦車が勝利。キルするたびに次のゾーン縮小が早まります。",
    brAliveCount: "残り{count}人",
    brZoneShrinking: "ゾーン縮小中！",
    brZoneNextShrink: "ゾーン縮小まで{seconds}秒",
    killsToWin: "勝利に必要なキル",
    timeLimitMinutes: "制限時間（分）",
    livesPerPlayer: "プレイヤーごとのライフ",
    damage: "ダメージ",
    speed: "速度",
    health: "体力",
    waitingPlayers: "プレイヤーを待機中...",
    closeRoom: "🚫 ルーム閉鎖",
    matchRules: "マッチルール",
    waitingHost: "ホストがゲームを開始するのを待機中...",
    leaveRoom: "← ルーム退出",
    reconnecting: "再接続中...",
    chooseArena: "アリーナを選択",
    chooseArenaDesc: "全プレイヤーのアリーナになります",
    arenaLarge: "大きなアリーナ",
    arenaMedium: "中くらいのアリーナ",
    arenaStandard: "標準アリーナ",
    random: "ランダム",
    randomOnCreate: "ルーム作成時にランダム",
    randomArena: "🎲 ルーム作成時にランダム",
    yourName: "あなたの名前",
    nameFromProfileHint: "プロフィールのエイリアスが自動的に使用されます。変更はプロフィールで行ってください。",
    nextChooseArena: "次へ：アリーナ選択 →",
    connectionLost: "接続が切れました",
    tryingToReconnect: "前のルームに再接続を試みています...",
    tryingReconnect: "前のルームに再接続を試みています...",
    disconnectedFromMatch: "マッチから切断されました。",
    reconnect: "再接続",
    ignore: "無視",
    waitingMorePlayers: "他のプレイヤーを待機中",
    loadingArena: "アリーナを読み込み中...",
    matchStarting: "まもなくバトル開始！",
    countdownGo: "GO!",
    creatingRoom: "ルーム作成中...",
    joining: "参加中...",
    connectingToServer: "サーバーに接続中...",
    connectingServer: "サーバーに接続中...",
    playersAndBots: "プレイヤーとボット",
    maxPlayersLabel: "最大プレイヤー数 (2-16)",
    botsFillSlots: "ボット（空き枠を補充）",
    none: "なし",
    botDifficulty: "ボット難易度",
    botEasy: "簡単",
    botNormal: "普通",
    botHard: "難しい",
    autoFillBots: "ボット自動補充",
    removeBotsOnJoin: "参加時にボットを削除",
    adaptiveBots: "適応型ボット",
    tankSpecials: "戦車パワー",
    tankSpecialsHint: "系譜パワー（シールド、ステルス、再生など）がこの部屋で有効になります。オフにすると完全に中立なアリーナになります。",
    itemsAndPowerups: "アイテムとパワーアップ",
    enableAllItems: "すべて有効",
    disableAllItems: "すべて無効",
    noItemsEnabledWarning: "有効なアイテムがありません。パワーアップなしで開始されます。",
    botStatusSummary: "人間: {humans} | 稼働ボット: {activeBots} | 設定: {configuredBots} | 想定合計: {projected}/{max}",
    botFineTuning: "ボット微調整",
    modeDeathmatchWithKills: "デスマッチ ({kills} キル)",
    modeTimedWithMinutes: "{minutes}分",
    modeLivesWithCount: "{lives} ライフ",
    spectatorModeTitle: "観戦モード",
    spectatingPlayer: "{player} を観戦中",
    spectatorGenericPlayer: "プレイヤー",
    nextSpectator: "次の観戦対象",
    exitRoom: "ルーム退出",
    alivePlayersTitle: "生存プレイヤー",
    errorOnlyHostRules: "ルールを変更できるのはホストのみです",
    errorRulesWaitingOnly: "ルールは試合開始前のみ変更できます",
    errorNeedTwoPlayers: "開始には最低2人（人間 + ボット）が必要です",
    errorPlayersNotReady: "全プレイヤーの準備が完了していません",
    errorOnlyHostResume: "再開できるのはホストまたは一時停止したプレイヤーのみです",
    errorColorInUse: "その色は他のプレイヤーが使用中です",
    errorOnlyHostRestart: "再開できるのはホストのみです",
    errorGameNotFinished: "試合はまだ終了していません",
    errorConnectFailed: "サーバーへの接続に失敗しました",
    errorCreateRoomFailed: "ルーム作成に失敗しました",
    errorRoomNotFound: "ルームが見つかりません",
    myFriends: "マイフレンド",
    goToLobby: "ロビーに戻る",
    backToMenu: "メニューに戻る",
  },

  br: {
    victory: "勝利！",
    champion: "バトルロイヤル王者",
    position: "順位",
    kills: "キル",
    players: "プレイヤー",
    score: "スコア",
    reward: "報酬",
    chips: "チップ",
    claimReward: "報酬を受け取る",
    rewardClaimed: "報酬を受け取りました！",
    totalChips: "合計: {count} チップ",
    backToMenu: "メニューに戻る",
    itemsNote: "アイテムは次の試合の初期装備になります",
    eliminated: "撃破された",
    ofPlayers: "{count}人中",
    spectate: "観戦 ({count})",
    menu: "メニュー",
    alive: "残り{count}人",
    zone: "ゾーン: {size}m",
    exit: "退出",
    winner: "勝者",
    nextTarget: "次へ",
    matchOver: "試合終了",
    noSurvivors: "生存者なし",
    playAgain: "もう一度プレイ",
    itemShield: "エクストラシールド",
    itemIntense: "インテンスパワー",
    itemFreeze: "フリーズ",
    itemHeal: "メディキット",
    itemMystery: "ミステリーボックス",
  },
  friends: {
    title: "マイフレンド",
    myFriends: "マイフレンド",
    matchesTogether: "一緒にプレイした試合",
    total: "合計",
    victories: "勝利",
    defeats: "敗北",
    winRate: "勝率",
    yourKills: "あなたのキル",
    yourDeaths: "あなたのデス",
    kd: "K/D",
    asAllies: "味方として",
    matches: "試合",
    estimatedMovement: "推定移動距離",
    distanceInMatches: "一緒にプレイした試合での距離",
    history: "履歴",
    firstMatch: "最初の試合",
    lastMatch: "最後の試合",
    totalSessions: "合計セッション",
    generalStats: "総合統計",
    list: "リスト",
    yourJourney: "あなたの旅",
    knownPlayers: "知り合いのプレイヤー",
    multiplayerMatches: "マルチプレイヤー試合",
    performance: "パフォーマンス",
    totalCombat: "合計戦闘",
    kills: "キル",
    deaths: "デス",
    totalDistance: "合計移動距離",
    distanceEstimate: "戦車の移動に基づく推定",
    recentMatches: "最近の試合",
    noFriendsYet: "まだフレンドがいません",
    playMultiplayer: "マルチプレイヤーをプレイして他のプレイヤーと出会おう！",
    recent: "最近",
    distance: "距離",
  },

  victory: {
    title: "🏆 勝利！",
    defeatTitle: "💀 敗北",
    yourStats: "あなたの統計",
    kills: "キル",
    deaths: "デス",
    finalScore: "最終スコア",
    playAgain: "もう一度プレイ",
    goToLobby: "ロビーに戻る",
    backToMenu: "メニューに戻る",
    won: "あなたの勝ち！",
    winner: "勝者",
  },

  options: {
    title: "⚙️ 設定",
    sound: "サウンド",
    music: "音楽",
    sfx: "効果音",
    vibration: "振動",
    language: "言語",
    graphics: "グラフィック",
    low: "低",
    medium: "中",
    high: "高",
    notifications: "通知",
    reset: "進行リセット",
    resetConfirm: "本当にリセットしますか？すべての進行が失われます。",
    // Expanded options
    mute: "ミュート",
    active: "アクティブ",
    disabled: "無効",
    generalVolume: "全体音量",
    effects: "エフェクト",
    maxFps: "最大FPS",
    camera: "カメラ",
    cameraTop: "トップ",
    cameraAngled: "斜め",
    cameraFirstPerson: "一人称",
    aiDifficulty: "AI難易度",
    // Haptics
    haptics: "触覚フィードバック",
    notSupported: "サポートされていません",
    hapticIntensity: "強度",
    testVibration: "振動テスト",
    // Voice Narration
    voiceNarration: "ボイスナレーション",
    voiceNarrationDesc: "ストーリーモードのダイアログで音声ナレーションを有効にします。追加の音声ダウンロードが必要です。",
    voiceVolume: "音声ボリューム",
    beta: "ベータ",
    // Controls
    controls: "コントロール",
    controlsDesc: "ゲームパッド、タッチ、マッピング",
    gamepadConnected: "コントローラー接続済み",
    noGamepad: "コントローラーが検出されません",
    connectGamepadHint: "Xbox、PlayStation、またはBluetoothコントローラーを接続してください",
    mobileCompatibility: "モバイル互換性",
    mobileAndroid: "ペアリング済みBluetoothコントローラーが自動的に動作します",
    mobileIOS: "限定サポート（MFiコントローラーのみ）",
    mobileMapping: "ブラウザのGamepad APIで自動マッピング",
    visualFeedback: "ビジュアルフィードバック（コントローラーをテスト）",
    leftStick: "左スティック",
    rightStick: "右スティック",
    buttonsPressed: "押されているボタン",
    noButtonPressed: "ボタンが押されていません",
    controlMapping: "コントロールマッピング",
    movement: "移動",
    shoot: "発射",
    useItem: "アイテム使用",
    astra: "アストラ（ストーリー）",
    astraHint: "チャージ時",
    jump: "ジャンプ",
    dash: "ダッシュ",
    pause: "ポーズ",
    touch: "タッチ",
    touchHint: "画面上のボタン",
    gamepadSettings: "コントローラー設定",
    deadzone: "デッドゾーン",
    deadzoneHint: "タンクが勝手に動く場合は調整してください",
    sensitivity: "感度",
    invertY: "Y軸反転",
    invertYHint: "スティックの縦軸を反転します",
    gamepadVibration: "コントローラー振動",
    hideVirtualControls: "コントローラー接続時に仮想コントロールを非表示",
    unifiedControlsInfo: "すべてのモード（ソロ、ストーリー、バトルロイヤル）で同じ統一コントロールを使用します。",
    virtualJoystick: "バーチャルスティック",
  },

  difficulty: {
    easy: "イージー",
    easyDesc: "敵が遅く、ダメージも少ない。初心者に最適。",
    normal: "ノーマル",
    normalDesc: "バランスの取れた体験。標準ゲームモード。",
    hard: "ハード",
    hardDesc: "より賢い敵、より多くの体力とダメージ。頑張って！",
    extreme: "エクストリーム",
    extremeDesc: "最大の挑戦。最も勇敢な者だけに！",
  },

  graphics: {
    title: "グラフィック",
    subtitle: "品質、影、解像度",
    quality: "品質",
    qualityLow: "低",
    qualityMedium: "中",
    qualityHigh: "高",
    qualityDesc: "爆発、照明、影を自動調整",
    explosions: "爆発",
    advancedExplosions: "高度な爆発",
    advancedExplosionsDesc: "追加パーティクルと光効果",
    explosionLights: "爆発ライト",
    shockwave: "衝撃波",
    lighting: "照明",
    advancedLighting: "高度な照明",
    softShadows: "ソフトシャドウ",
    postProcessing: "ネオンブルーム（ポスト処理）",
    dynamicResolution: "動的解像度（自動）",
    shadowQuality: "影の品質",
    effects: "エフェクト",
    screenShake: "画面揺れ",
    screenShakeDesc: "爆発時のカメラ振動",
    performance: "パフォーマンス",
    dynamicOptimization: "動的最適化",
    dynamicOptimizationDesc: "30+ FPSを維持するためにエフェクトを自動調整",
    renderBackend: "レンダリングエンジン",
    webgpuUnavailable: "WebGPU利用不可",
    webgpuActive: "実験的WebGPU有効 - パフォーマンス向上",
    fpsTarget: "FPSターゲット",
    resolution: "解像度",
    fpsMonitor: "FPSモニター",
    fpsMonitorDesc: "ゲーム中のドラッグ可能モニター",
    tensionMonitor: "音楽テンションモニター",
    tensionMonitorDesc: "アダプティブ音楽の強度レベルを表示",
    bottomBar: "ボトムバー",
    bottomBarDesc: "プロフィール、コイン、通知バー",
    advancedSettings: "詳細設定",
    advancedSettingsDesc: "パフォーマンスとエフェクトの詳細調整",
    interfaceSection: "インターフェース",
    quickOptions: "クイック設定",
    autoDetectReset: "推奨FPS・グラフィック設定に戻す（自動検出）",
    recommended: "推奨",
    motion: "インターフェースの動き",
    motionDesc: "メニューのトランジション・グロー・アニメーション。「自動」はシステム設定に従います。",
    motionAuto: "自動",
    motionFull: "フル",
    motionReduced: "控えめ",
    activeEffects: "有効なエフェクト:",
    autoReducedForFps: "（FPS維持のため自動的に引き下げ）",
    reducedMotionActive: "動きを抑制中",
  },

  rewards: {
    daily: "デイリー報酬",
    dailyDesc: "毎日戻って報酬を獲得！",
    claim: "受け取る",
    claimed: "受け取り済み",
    streak: "連続",
    day: "日目",
    comeBackTomorrow: "明日また来てね！",
    // DailyRewards expanded
    week1: "第1週",
    week2: "第2週",
    week3: "第3週",
    week4: "第4週",
    megaFinal: "メガファイナル",
    enterDaily: "毎日ログインしよう！",
    record: "記録",
    currentDay: "現在の日",
    collect: "受け取る！",
    nextSpecialReward: "次のスペシャル報酬",
    daysLeft: "残り日数",
    monthlyProgress: "月間進捗",
    rewardCollected: "報酬を受け取りました！",
    comeBackTomorrowMore: "明日また来てね",
    // New labels
    title: "🎁 報酬",
    sequence: "連続",
    xpBoost: "XPブースト！",
    chipsBoost: "チップスブースト！",
    days: "日",
    collectReward: "報酬を受け取る！",
    daysInRow: "日連続！",
    thisMonth: "今月",
    pending: "保留中",
  },

  battlePass: {
    noActiveSubscription: "有効なサブスクリプションはありません",
    title: "バトルパス",
    subtitle: "シーズン1 • ミッション • 限定報酬",
    free: "無料",
    premium: "プレミアム",
    level: "レベル",
    xp: "XP",
    unlock: "アンロック",
    getPremium: "プレミアム取得",
    // BattlePassView expanded
    mostPopular: "人気No.1",
    choosePlan: "プランを選択",
    allPlansInclude: "すべてのプランにプレミアムバトルパスが含まれます！",
    cancelAnytime: "いつでもキャンセル可能。Stripeによる安全な支払い。",
    collectReward: "報酬を受け取る",
    rewardCollected: "✓ 報酬受け取り済み",
    passActive: "✓ パス有効",
    timeRemaining: "残り時間",
    activatePremium: "プレミアムパスを有効化",
    choosePlanDesc: "ブロンズ、シルバー、またはゴールドパスを選択",
    missions: "📋 ミッション",
    dailyMissions: "☀️ デイリーミッション",
    dailyMissionsReset: "（深夜にリセット）",
    weeklyMissions: "📅 ウィークリーミッション",
    weeklyMissionsReset: "（月曜にリセット）",
    loadingMissions: "ミッションを読み込み中...",
    // Subscription plans
    bronzePass: "ブロンズパス",
    silverPass: "シルバーパス",
    goldPass: "ゴールドパス",
    perMonth: "/月",
    crystalsPerDay: "クリスタル/日",
    chipsPerDay: "チップ/日",
    xpAndChipsBonus: "+{percent}% XPとチップ",
    noAds: "広告なし",
    extraDailyMission: "+{count} デイリーミッション",
    exclusiveSkin: "月間限定スキン",
    priorityQueue: "優先キュー",
    subscribe: "登録",
    crystalsValue: "¥{value}相当のクリスタル！",
    collect: "受け取る",
    collected: "✓ 受け取り済み",
    season: "シーズン",
    ofLevel: "の",
    backToMenu: "← メニューに戻る",
    rewards: "🎁 報酬",
    // Subscription management
    manageSubscription: "サブスクリプション管理",
    managePayment: "支払い管理",
    cancelSubscription: "サブスクリプションをキャンセル",
    reactivateSubscription: "サブスクリプションを再開",
    subscriptionActive: "サブスクリプション有効",
    subscriptionCanceled: "サブスクリプションキャンセル済み",
    expiresAt: "{date}に期限切れ",
    confirmCancel: "本当にキャンセルしますか？現在の期間終了まで利用できます。",
    reactivate: "サブスクリプションを再有効化",
    cancelsPeriodEnd: "期間終了時にキャンセル",
    renewsAt: "{date}に更新",
    daysRemaining: "残り日数",
    crystalsReceived: "獲得クリスタル",
    subscriptionEnding: "サブスクリプションは{date}に終了します",
    supportContact: "ご質問は？ support@rocketanks.com",
    active: "有効",
    canceling: "キャンセル中",
  },

  creators: {
    title: "🎬 クリエイター",
    enterCode: "クリエイターコードを入力",
    yourCode: "あなたのコード",
    totalReferrals: "紹介数合計",
    useCode: "コードを使用",
    codeUsed: "コード使用済み！",
    invalidCode: "無効なコード",
    ownCode: "自分のコードは使用できません",
    share: "共有",
    copied: "コピーしました！",
    // CreatorCode expanded
    codeApplied: "{name}のコードを適用しました！{discount}%割引。",
    activeCode: "有効なコード",
    enterCreatorCode: "クリエイターコードを入力",
    apply: "適用",
    becomeCreator: "クリエイターになる",
    earnCommission: "フォロワーがあなたのコードで購入すると手数料がもらえます",
    supportCreator: "お気に入りのクリエイターを応援",
    getDiscount: "して購入時に割引を受けよう",
    // CreatorDashboard
    creatorDashboard: "クリエイターダッシュボード",
    yourCreatorCode: "あなたのクリエイターコード",
    commission: "手数料",
    discountForFans: "ファン向け割引",
    creatorPoints: "クリエイターポイント",
    pendingValidation: "承認待ち",
    pendingValidationDesc: "登録は審査中です。承認されると通知が届きます。通常48時間以内です。",
    verifiedCreator: "認定クリエイター",
    verifiedCreatorDesc: "おめでとうございます！あなたは公式Rocketanksクリエイターです。名前の横にバッジが表示されます！",
    registerAsCreator: "クリエイターとして登録",
    overview: "📊 概要",
    points: "⭐ ポイント",
    referrals: "👥 紹介",
    rewardsTab: "🎁 報酬",
    // Dashboard Overview
    totalEarnings: "総収益",
    totalUses: "総使用回数",
    totalReferralsLabel: "総紹介数",
    withdrawEarnings: "収益を出金",
    minWithdrawal: "最小出金額: 50クリスタル",
    topSupporters: "🏆 トップサポーター",
    tierBenefits: "特典",
    // Points Panel
    creatorPointsBalance: "クリエイターポイント",
    totalEarnedPoints: "総獲得: {count}ポイント",
    howToEarnPoints: "ポイントの獲得方法",
    convertPoints: "ポイント交換",
    convertPointsDesc: "ポイントをゲーム内報酬と交換",
    crystals: "クリスタル",
    chips: "チップ",
    convertPointsBtn: "{count}ポイントを交換",
    insufficientPoints: "ポイント不足（現在{count}）",
    conversionHistory: "📜 交換履歴",
    // Referrals Panel
    activeReferrals: "アクティブ（30日間）",
    inviteFriends: "友達を招待！",
    inviteFriendsDesc: "コードを共有して、新しいプレイヤーごとに{points}ポイントを獲得！",
    yourReferrals: "あなたの紹介",
    yourReferralsDesc: "登録時にあなたのコードを使用したプレイヤー",
    noReferralsYet: "まだ紹介がありません",
    shareCodeToStart: "コードを共有して始めましょう！",
    joinedOn: "{date}に参加",
    // Rewards Panel
    exclusiveCreatorItems: "クリエイター限定アイテム",
    exclusiveCreatorItemsDesc: "クリエイターだけが入手できるアイテムをアンロック！",
    creatorSkin: "クリエイタースキン",
    creatorSkinDesc: "認定クリエイター限定",
    creatorEffect: "クリエイターエフェクト",
    creatorEffectDesc: "限定スペシャルトレイル",
    pixRewards: "PIX報酬",
    pixRewardsDesc: "リアルマネーを受け取る方法を準備中です！",
    pixWithdraw: "PIX出金",
    pixWithdrawDesc: "収益を現金に変換",
    pixMonthlyRaffle: "月間PIX抽選",
    pixMonthlyRaffleDesc: "アクティブなクリエイターが現金賞品を競います",
    comingSoon: "近日公開",
    stayTuned: "最新情報をお見逃しなく！ゲームを宣伝すればするほど、報酬も大きくなります。",
    confirmRedemption: "交換を確認",
    confirmRedemptionDesc: "クリエイター限定アイテムを交換しようとしています。",
    cancel: "キャンセル",
    confirm: "確認",
    // Register Dialog
    registerAsCreatorTitle: "クリエイターとして登録",
    registerAsCreatorDesc: "審査のためにSNSを入力してください。承認されると、認定クリエイターバッジがもらえます！",
    validationNotice: "登録は48時間以内に手動で審査されます。承認されたクリエイターには特別なバッジが付与されます！",
    followers: "フォロワー",
    fillOneSocialMedia: "少なくとも1つのSNSを入力してください",
    registrationError: "登録エラー",
    submitForReview: "審査に送信",
  },

  referral: {
    title: "紹介",
    yourCode: "あなたのコード",
    copied: "✓ コピーしました！",
    copy: "📋 コピー",
    share: "📤 共有",
    friendsUseCode: "友達があなたのコードを使うと、お互いに",
    bothGet: "100 ⚡ チップ",
    friendCode: "友達のコード？",
    alreadyUsedCode: "✓ 紹介コードを使用済み",
    redeemAndEarn: "🎁 交換して100 ⚡ゲット",
    enterCode: "コードを入力！",
    codePlaceholder: "例: TANK-ABC12",
    errorUsingCode: "コード使用エラー",
    connectionError: "接続エラー。再試行してください。",
    shareMessage: "🎮 Rocketanksを一緒にプレイしよう！私のコード{code}を使って100 ⚡チップを無料ゲット！\n\nhttps://rocketanks.nagentes.com",
  },

  credits: {
    title: "クレジット",
    developer: "開発者",
    mainTester: "メインテスター",
    sponsors: "スポンサー",
    sponsorsDesc: "Rocketanksの最大のサポーターがここに表示されます！",
    comingSoon: "近日公開...",
    buyCrystals: "クリスタルを購入してここに名前を載せよう！",
    allRightsReserved: "全著作権所有",
  },

  ranked: {
    profile: "ランクプロフィール",
    trophies: "トロフィー",
    victories: "勝利",
    defeats: "敗北",
    winRate: "勝率",
    highestTrophies: "最高トロフィー",
    currentStreak: "現在の連勝",
    bestStreak: "最高連勝: {count}勝",
    recentMatches: "最近の試合",
    classification: "ランキング",
    global: "グローバル",
    myLeague: "マイリーグ",
    friends: "フレンド",
    yourPosition: "あなたの順位",
    noPlayersFound: "プレイヤーが見つかりません",
  },

  tournaments: {
    title: "🏆 トーナメント",
    subtitle: "賞品付き大会",
    selectToJoin: "参加するトーナメントを選択",
    noTournamentAvailable: "利用可能なトーナメントはありません",
    newTournamentSoon: "新しいトーナメントがまもなく作成されます",
    players: "プレイヤー",
    open: "オープン",
    almostFull: "満員間近",
    join: "参加",
    leaveTournament: "トーナメントを退出",
    entry: "参加費",
    free: "無料",
    firstPlace: "1位",
    duration: "所要時間",
    minutes: "分",
    tournaments: "トーナメント",
    victories: "勝利",
    top3: "トップ3",
    prizes: "賞品",
    registering: "登録中",
    inProgress: "進行中",
    completed: "完了",
    waitingPlayers: "プレイヤーを待っています...",
    round: "ラウンド",
    final: "決勝",
    participants: "参加者",
    yourNextMatch: "次の試合",
    place: "位",
    bronze: "ブロンズ",
    silver: "シルバー",
    gold: "ゴールド",
    diamond: "ダイヤモンド",
    unknownError: "不明なエラー",
    tournamentsPlayed: "参加トーナメント数",
    tournamentsWon: "優勝回数",
    top3Rate: "トップ3率",
    totalPrizeWon: "獲得賞品総額",
  },

  clan: {
    title: "⚔️ クラン",
    subtitle: "他のプレイヤーと協力",
    noClan: "クランに所属していません",
    noClanDesc: "クランに参加して戦争に参加し、報酬を獲得しよう！",
    officialClans: "公式クラン",
    officialClansFree: "公式クラン（無料）",
    viewOfficialClans: "公式クランを見る",
    searchClan: "クランを検索",
    createClan: "クランを作成",
    joinClan: "クランに参加",
    leaveClan: "クランを退出",
    leader: "リーダー",
    coLeader: "サブリーダー",
    elder: "長老",
    member: "メンバー",
    promote: "昇格",
    demote: "降格",
    kick: "追放",
    agoMinutes: "{count}分前",
    agoHours: "{count}時間前",
    agoDays: "{count}日前",
    perWeek: "/週",
    noMessages: "まだメッセージはありません",
    clanMessage: "クランメッセージ...",
    trophies: "トロフィー",
    donations: "寄付",
    lastActive: "最終アクティブ",
    members: "メンバー",
    clanLevel: "クランレベル",
    clanWars: "クラン戦",
    clanName: "クラン名",
    clanTag: "クランタグ",
    clanDescription: "説明",
    clanIcon: "アイコン",
    createClanBtn: "クランを作成",
    searchPlaceholder: "名前またはタグで検索...",
    noClansFound: "クランが見つかりません",
    availableClans: "利用可能なクラン 7",
    basedOnStoryMode: "ストーリーモードベース",
    clanTypes: "クランタイプ",
    publicClans: "公開",
    publicClansDesc: "無料、管理者が運営",
    privateClans: "プライベート",
    privateClansDesc: "作成 500💎、メンバー 500💎",
    official: "公式",
    all: "すべて",
    beginners: "初心者",
    story: "ストーリー",
    freeOfficialClansInfo: "無料! 公式クランは参加料金がありません。",
    adminRevenueInfo: "管理者はメンバーXPに基づいて収益の5%を受け取ります",
    privateType: "プライベート",
    publicType: "公開",
    publicOfficialOnly: "公式クランのみ",
    clanNamePlaceholder: "例: 無敵タンク",
    clanTagPlaceholder: "例: TANK",
    clanDescriptionPlaceholder: "クランの説明を入力...",
    costSummary: "コスト概要",
    createClanCost: "クラン作成:",
    memberFee: "メンバーごとの料金:",
    free: "無料",
    creating: "作成中...",
    info: "情報",
    wins: "勝利",
    level: "レベル",
    noDescription: "説明なし",
    warsComingSoon: "近日公開! 他のクランと戦って豪華報酬を獲得しよう。",
    inDevelopment: "開発中",
  },

  replays: {
    title: "🎬 リプレイ",
    subtitle: "ベストマッチを見直そう",
    noReplays: "保存されたリプレイはありません",
    noReplaysDesc: "試合は自動的に保存されます",
    lastMatch: "最後の試合",
    lastMatchDesc: "ゲームモードごとに1つのリプレイを自動保存",
    importReplay: "リプレイをインポート",
    exportReplay: "エクスポート",
    shareReplay: "共有",
    deleteReplay: "削除",
    play: "再生",
    pause: "一時停止",
    survival: "サバイバル",
    multiplayer: "マルチプレイヤー",
    story: "ストーリー",
    duration: "所要時間",
    players: "プレイヤー",
    wave: "ウェーブ",
    views: "視聴回数",
    importTitle: "リプレイをインポート",
    importPlaceholder: "リプレイコードをここに貼り付け...",
    import: "インポート",
    codeCopied: "コードをコピーしました！",
    // Viewer
    viewer: "リプレイビューア",
    speed: "速度",
    stop: "停止",
    resume: "再開",
    replayEnded: "リプレイ終了",
    dragTimeline: "ドラッグして移動",
    snapshot: "スナップショット",
    events: "イベント",
    // Tags
    tagMultiKill: "マルチキル",
    tagClutch: "クラッチ",
    tagPerfectWave: "パーフェクトウェーブ",
    tagLongGame: "長期戦",
    tagHighScore: "ハイスコア",
    tagFlawless: "ノーデス",
    // Toast
    shareCopied: "共有リンクをコピーしました！",
    exportCopied: "リプレイをエクスポートしてコピーしました！",
    shareError: "リプレイの共有に失敗しました",
    exportError: "リプレイのエクスポートに失敗しました",
    deleteConfirm: "このリプレイを削除しますか？",
  },

  subscription: {
    errorTitle: "エラーが発生しました",
    closeError: "閉じる",
    title: "⭐ サブスクリプション",
    subtitle: "限定特典をアンロック",
    free: "無料",
    freePlan: "無料プラン",
    bronzePass: "ブロンズパス",
    silverPass: "シルバーパス",
    goldPass: "ゴールドパス",
    perMonth: "/月",
    dailyCrystals: "クリスタル/日",
    dailyChips: "チップ/日",
    xpBonus: "+{percent}% XP",
    noAds: "広告なし",
    exclusiveSkin: "月間限定スキン",
    priorityQueue: "優先キュー",
    dailyRewards: "デイリー報酬",
    available: "利用可能！",
    claimedToday: "本日受取済み",
    claimNow: "今すぐ受け取る",
    claiming: "受取中...",
    claimed: "受取済み: {crystals}クリスタル + {chips}チップ！",
    manageSubscription: "サブスク管理",
    upgrade: "アップグレード",
    viewPlans: "プランを見る",
    cancelSubscription: "サブスクをキャンセル",
    canceledAt: "{date}にキャンセル",
    months: "ヶ月",
    month: "ヶ月",
    totalReceivedMonth: "今月の受取総額：",
    totalCrystals: "クリスタル",
    totalChips: "チップ",
    crystalsValue: "¥{value}相当のクリスタル！",
    unlockDailyRewards: "限定デイリー報酬をアンロック！",
    // SubscriptionCard dialog
    plansTitle: "サブスクリプションプラン",
    plansDescription: "最適なプランを選んで、限定デイリー報酬を受け取ろう！",
    mostPopular: "一番人気",
    receiveDaily: "毎日受け取れる：",
    currentPlan: "現在のプラン",
    processing: "処理中...",
    lowerPlan: "下位プラン",
    subscribe: "登録する",
    loginToSubscribe: "登録するにはログインしてください",
    confirmCancelMessage: "サブスクリプションをキャンセルしますか？現在の期間終了まで利用可能です。",
    reactivateSubscription: "サブスクを再開",
    paymentSecure: "Stripeによる安全な決済",
    cancelNoFee: "いつでもキャンセル可能、手数料なし",
    rewardsAccumulate: "ログインしない日も報酬は蓄積されます",
    instantUpgrade: "即時アップグレード、日割り差額請求",
    claimedRewards: "✓ 受取済み: {crystals}クリスタル + {chips}チップ！",
    // Dynamic feature templates
    featureBattlePassPremium: "バトルパスプレミアム",
    featureCrystalsDaily: "クリスタル/日",
    featureChipsDaily: "チップ/日",
    featureXpChipsBonus: "XPとチップ",
    featureNoAds: "広告なし",
    featureExclusiveSkins: "限定スキン",
    featurePriorityQueue: "優先キュー",
    featureExtraMissions: "デイリーミッション追加",
    featureFreeChipsDaily: "デイリーチップ",
    featureBasicAccess: "基本ゲームアクセス",
    valueInCrystals: "¥{value}相当のクリスタル！",
  },

  genAI: {
    // Personalities
    aggressive: "アグレッシブ 🔥",
    defensive: "ディフェンシブ 🛡️",
    strategic: "ストラテジック 🧠",
    player: "プレイヤー",
    // Victory messages
    battleComplete: "バトル完了！",
    youWon: "勝利！",
    youLost: "敗北！",
    aiVsAiMode: "AI対AIモード",
    playerVsAiMode: "プレイヤー対AIモード",
    model: "モデル",
    winningModel: "勝利モデル",
    menu: "メニュー",
    playAgain: "もう一度プレイ",
  },

  rankedProfile: {
    title: "ランクプロフィール",
    trophies: "トロフィー",
    trophiesToNextTier: "{tier}まであと{count}トロフィー",
    victories: "勝利",
    defeats: "敗北",
    winRate: "勝率",
    highestTrophies: "最高トロフィー",
    currentStreak: "現在の連勝",
    bestStreak: "最高連勝: {count}勝",
    recentMatches: "最近の試合",
    winsLabel: "勝",
  },

  marketplace: {
    explore: "探索",
    create: "作成",
    myItems: "マイアイテム",
    history: "履歴",
    createBuySell: "ユニークなアイテムを作成、購入、販売しよう！",
    sale: "販売",
    auction: "オークション",
    trade: "トレード",
    free: "無料",
    // New labels
    title: "マーケットプレイス",
    subtitle: "他のプレイヤーとアイテムを売買・交換しよう",
    searchItems: "アイテムを検索...",
    noItemsFound: "アイテムが見つかりません",
    adjustFilters: "フィルターを調整してみてください",
    all: "すべて",
    skins: "スキン",
    effects: "エフェクト",
    tanks: "戦車",
    badges: "バッジ",
    backToMenu: "← メニューに戻る",
    feeInfo: "手数料",
    // Tabs
    tabs: {
      browse: "探索",
      flash: "フラッシュ",
      bundles: "バンドル",
      create: "作成",
      myItems: "マイアイテム",
      profile: "プロフィール",
      history: "履歴",
    },
    // Fees
    fees: {
      sale: "販売",
      auction: "オークション",
      trade: "トレード",
      royalties: "ロイヤリティ",
      level: "レベル",
      discount: "割引",
    },
    // Content creation
    createContent: "🎨 コンテンツ作成",
    createContentDesc: "マーケットプレイスで販売するユニークなアイテムを作成",
    contentType: "アイテムタイプ",
    itemName: "アイテム名",
    itemDescription: "説明（任意）",
    skinColor: "カラースキン",
    visualEffect: "ビジュアルエフェクト",
    sticker: "ステッカー",
    skinColorDesc: "戦車のカスタムカラー",
    visualEffectDesc: "ユニークな軌跡や爆発",
    stickerDesc: "装飾画像（64x64）",
    colors: "色",
    gradient: "グラデーション",
    primaryColor: "プライマリカラー",
    secondaryColor: "セカンダリカラー",
    preview: "プレビュー",
    uploadImage: "ステッカー画像",
    clickToUpload: "クリックしてアップロード",
    clickToChange: "クリックして変更",
    imageRules: "PNG、JPGまたはWebP • 最大64x64px • 最大50KB",
    moderationWarning: "⚠️ 画像は64x64にリサイズされ、承認前にモデレーションを受けます。",
    submitForApproval: "承認申請",
    submitting: "送信中...",
    submitted: "✓ 送信完了！",
    itemSentModeration: "アイテムをモデレーションに送信しました！",
    moderationNotify: "承認されると通知されます。",
    // Content rules
    contentRules: "📋 コンテンツルール：",
    originalOnly: "オリジナルコンテンツのみ",
    noOffensive: "不適切な画像禁止",
    noLogos: "商標やロゴ禁止",
    moderationTime: "モデレーションは最大24時間",
    // My items tabs
    selling: "販売中",
    sold: "売却済み",
    pending: "保留中",
    // Listing status
    active: "アクティブ",
    expired: "期限切れ",
    soldStatus: "売却済み",
    // Transaction history
    totalEarned: "総収益",
    totalSpent: "総支出",
    noTransactions: "取引履歴なし",
    soldTo: "{name}に販売",
    boughtFrom: "{name}から購入",
    // Listing details
    price: "価格",
    currentBid: "現在の入札",
    yourBid: "あなたの入札（最低: {min}）",
    minBid: "最低",
    buyNow: "今すぐ購入",
    placeBid: "入札する",
    processing: "処理中...",
    insufficientCrystals: "クリスタル不足",
    purchasesUnavailable: "購入利用不可",
    cancel: "キャンセル",
    // Flash sales
    noFlashSales: "アクティブなフラッシュセールなし",
    flashSalesDesc: "フラッシュセールは期間限定の特別割引です。後でまたチェックしてください！",
    endsIn: "終了まで",
    remaining: "残り{count}/{total}",
    soldOut: "売り切れ",
    buy: "購入",
    unavailable: "利用不可",
    // Featured
    official: "✓ 公式",
    officialDesc: "プレミアムスキンとエフェクト • Rocketanks公式セラー",
    viewItems: "アイテムを見る →",
    createYourSkins: "✨ 自分だけのスキンを作ろう！",
    createYourSkinsDesc: "色やエフェクトをカスタマイズして販売でロイヤリティを獲得",
    // Validation errors
    nameMinChars: "名前は3文字以上必要です",
    nameBannedWord: "名前に禁止用語が含まれています",
    invalidColor: "無効な色（#RRGGBB形式を使用）",
    imageRequired: "ステッカーには画像が必要です",
    fileTooLarge: "ファイルが大きすぎます（最大{size}KB）",
    invalidImage: "ファイルは画像である必要があります",
    imageProcessError: "画像処理エラー",
    // Offer
    offer: "オファー",
    // Type badges
    saleType: "販売",
    auctionType: "オークション",
    tradeType: "トレード",
    // Telas de vendedor, pacotes e moderação
    itemSentForModeration: "アイテムを審査に送信しました！",
    willBeNotified: "承認されたらお知らせします。",
    rule1: "オリジナル、または使用権のあるコンテンツのみ",
    rule2: "攻撃的・過度に暴力的・未成年に不適切な内容は禁止",
    rule3: "他社のブランド・ロゴ・キャラクターは禁止",
    rule4: "ルール違反のアイテムは返金なしで削除されます",
    noItemsForSale: "販売中のアイテムはありません",
    noItemsSold: "まだ売れたアイテムはありません",
    noItemsPending: "承認待ちのアイテムはありません",
    purchasedFrom: "{name} から購入",
    purchasesDisabledWarning: "このアカウントではマーケットプレイスでの購入はできません。",
    purchasesUnavailableShort: "購入できません",
    purchaseFailed: "購入を完了できませんでした",
    bundlesAndCollections: "バンドルとコレクション",
    bundlesDesc: "クリエイターが組んだ割引アイテムセット",
    createBundle: "バンドルを作成",
    noBundles: "利用できるバンドルはありません",
    noBundlesDesc: "新しいコレクションはまた後で確認してください。",
    starterPack: "スターターパック",
    seasonal: "シーズン限定",
    themed: "テーマ",
    exclusive: "限定",
    buyBundle: "バンドルを購入",
    verificationSent: "認証リクエストを送信しました！",
    verificationFailed: "認証リクエストを送信できませんでした",
    save: "保存",
    noDescription: "説明なし",
    edit: "編集",
    followers: "フォロワー",
    sales: "販売数",
    sellerLevel: "セラーレベル",
    progressToLevel: "レベル{level}までの進捗",
    xpToNextLevel: "次のレベルまであと {xp} XP",
    maxLevelReached: "最大レベルに到達！",
    feeDiscount: "手数料割引",
    activeListings: "出品数上限",
    auctions: "オークション",
    bundles: "バンドル",
    creatorStats: "クリエイター統計",
    contentsCreated: "作成コンテンツ",
    downloads: "ダウンロード",
    likes: "いいね",
    royaltiesEarned: "獲得ロイヤリティ",
    requestVerification: "認証をリクエスト",
    verificationBenefits: "認証済みセラーはプロフィールにバッジが付き、検索で目立ちやすくなります。リクエストはチームが審査します。",
    creator: "クリエイター",
    creatorReq: "マーケットプレイスにオリジナル作品を公開",
    artist: "アーティスト",
    artistReq: "スキンやアートの作品集を提示",
    streamer: "ストリーマー",
    streamerReq: "定期的にゲームを配信",
  },

  shopEffects: {
    trail: "🔥 軌跡",
    explosion: "💥 爆発",
    shot: "⚡ ショット",
    aura: "✨ オーラ",
    movement: "💨 移動",
    special: "🌟 スペシャル",
  },

  ui: {
    dailyRewards: "デイリー報酬",
    changeTank: "戦車を変更",
    summary: "サマリー",
    battles: "バトル",
    wins: "勝利",
    kills: "撃破",
    winRate: "勝率",
    touchToStart: "タップして開始",
    starting: "開始中...",
    mobileControls: "モバイル：左タップで移動、右で発射",
    desktopControls: "デスクトップ：WASDまたは矢印で移動、スペースで発射",
    shopAndRewards: "ショップ＆報酬",
    shop: "ショップ",
    rewards: "報酬",
    creators: "クリエイター",
    refer: "招待",
    // Update notification
    newVersionAvailable: "新バージョンが利用可能！",
    updateReady: "Rocketanksのアップデートが準備できました。",
    updating: "アップデート中...",
    updateNow: "今すぐアップデート",
    later: "後で",
    // Error boundary
    somethingWentWrong: "🚀 おっと！エラーが発生しました",
    unknownError: "不明なエラー",
    reloadPage: "ページを再読み込み",
    technicalDetails: "技術詳細（開発者向け）",
    screenLoadError: "この画面の読み込み中にエラーが発生しました。もう一度お試しください。",
    chips: "チップ",
    crystals: "クリスタル",
    missions: "ミッション",
    notifications: "お知らせ",
    viewList: "リスト",
    viewCards: "カード",
    backToMenu: "← メニューに戻る",
    offline: "インターネットに接続されていません",
    // Chapters
    comingSoon: "近日公開",
    replay: "リプレイ",
    play: "プレイ",
  },

  story: {
    missionFailed: "ミッション失敗",
    missionFailedDesc: "戦車が破壊されました。もう一度挑戦しよう！",
    tryAgain: "もう一度",
    backToChapters: "チャプター選択に戻る",
    exitStory: "✕ 終了",
    tapToContinue: "タップして続ける",
    chapter: "チャプター{chapter}",
    mode: "ストーリーモード",
    // Story Mode page
    title: "ストーリーモード",
    subtitle: "アーサー・レンとKITSUNE-00の物語",
    backToMenu: "← メニューに戻る",
    prologueLabel: "プロローグ",
    prologueTitle: "プロローグ",
    prologueDesc: "第1章の前：アーサーの目覚め",
    // Chapters
    chapters: {
      awakening: "覚醒",
      awakeningDesc: "KITSUNE-00との出会い",
      firstConflict: "最初の戦い",
      firstConflictDesc: "軍曹RØKに立ち向かえ",
      rescue: "救出",
      rescueDesc: "脱走エンジニアを守れ",
      iceStorm: "氷の嵐",
      iceStormDesc: "司令官ボレアルの試練",
      darkForest: "闇の森",
      darkForestDesc: "将軍ヴァーダントに挑め",
      finalVolcano: "最後の火山",
      finalVolcanoDesc: "アルカディアの心臓",
      shadowsOfPast: "過去の影",
      shadowsOfPastDesc: "断片化された記憶",
      iceAndSilence: "氷と静寂",
      iceAndSilenceDesc: "狐の墓場",
      theTraitor: "裏切り者",
      theTraitorDesc: "CORVUS-7が目覚める",
      prime: "PRIME",
      primeDesc: "最終決戦",
    },
  },

  greetings: {
    morning: "おはようございます！",
    afternoon: "こんにちは！",
    evening: "こんばんは！",
    lateNight: "夜更かし中！",
    restMessage1: "もう遅いね...1戦だけして休もう？",
    restMessage2: "休む時間！体は十分な睡眠に感謝します。",
    restMessage3: "まだ起きてる？健康に気をつけて、寝ましょう！",
    firstBattle: "初めてのバトルの準備はいい？",
    startingWell: "いいスタートだね！その調子！",
    keepGoing: "諦めないで！勝利はすぐそこ。",
    firstWin: "初勝利達成！次へ進もう！",
    moreWins: "{count}勝！上達してるね。",
    gettingBetter: "{count}勝！熟練した指揮官だ。",
    skilled: "{count}勝！戦争のベテラン！",
    veteran: "{count}勝！バトルの伝説！",
    legend: "{count}勝！最高の戦車マスター！",
    master: "{count}体撃破！止められない！",
    unstoppable: "{count}体！まさに戦争マシン！",
    warMachine: "{count}体！まさに戦争マシン！",
    richInChips: "チップ長者！全戦車アンロックした？",
  },

  errors: {
    connectionFailed: "接続失敗",
    serverError: "サーバーエラー",
    timeout: "タイムアウト",
    invalidInput: "無効な入力",
    permissionDenied: "許可が拒否されました",
    notFound: "見つかりません",
    cameraError: "カメラアクセスエラー",
    cameraInUse: "カメラは他のアプリで使用中",
    cameraNotFound: "デバイスにカメラがありません",
    httpsRequired: "セキュリティエラー。HTTPSを使用してください。",
  },

  auth: {
    tapToPlay: "🎮 タップしてプレイ",
    welcome: "ようこそ！",
    chooseLoginMethod: "ログイン方法を選択",
    loginWithGoogle: "Googleでログイン",
    loginWithDiscord: "Discordでログイン",
    loginWithEmail: "メールでログイン",
    comingSoon: "近日公開",
    unavailable: "利用不可",
    emailCodeSent: "📬 メールに送信された6桁のコードを入力してください。",
    emailCodePrompt: "確認コードをメールに送信します。",
    sendCode: "コードを送信 →",
    sending: "⏳ 送信中...",
    verifying: "⏳ 確認中...",
    confirmAndLogin: "✓ 確認してログイン",
    useAnotherEmail: "← 別のメールを使用",
    useAnotherAccount: "🔄 別のアカウントを使用",
    completeProfile: "🎯 プロフィールを完成",
    profileInfoNeeded: "開始するためにいくつかの情報が必要です",
    email: "メール",
    fullName: "氏名",
    fullNamePrivate: "（非公開）",
    publicAlias: "公開エイリアス",
    aliasChars: "（3-16文字）",
    birthDate: "生年月日",
    yourName: "あなたの名前",
    yourAlias: "your_alias",
    yourEmail: "your@email.com",
    saving: "⏳ 保存中...",
    saveAndPlay: "🚀 保存してプレイ！",
    welcomeBack: "おかえりなさい、",
    playNow: "🎮 今すぐプレイ",
    starting: "⏳ 開始中...",
    termsAgree: "以下に同意します：",
    termsOfUse: "利用規約",
    privacyPolicy: "プライバシーポリシー",
    aliasInUse: "エイリアスは既に使用中または無効です",
    aliasInvalid: "無効なエイリアス",
    // Bio / Profile
    bio: "自己紹介",
    bioPlaceholder: "自己紹介を書いてください...",
    clickToAddBio: "クリックして自己紹介を追加...",
    change: "変更",
    // Validation errors
    invalidEmail: "無効なメール",
    fullNameMinLength: "氏名は3文字以上必要です",
    aliasMinLength: "エイリアスは3-16文字（英数字、_）",
    birthDateRequired: "生年月日は必須です",
    profileSaveFailed: "プロフィールの保存に失敗",
    connectionError: "接続エラー。再試行してください。",
  },

  admin: {
    title: "管理パネル",
    loginError: "ログインエラー",
    playerNotFound: "プレイヤーが見つかりません",
    announcementPlaceholder: "お知らせの内容をここに入力...",
    search: "検索",
    searchPlayer: "プレイヤー検索",
    wins: "勝利",
    systemSettings: "システム設定",
    refreshData: "データを更新",
    settingLocked: "この設定はロックされています",
    dailyRewards: "デイリーリワード",
    successRate: "成功率",
    playerUUID: "プレイヤーUUID",
    minAge: "最小年齢",
    maxAge: "最大年齢",
    resetMemoriesConfirm: "すべてのAIメモリをリセットしますか？",
    genaiLearning: "AI学習システム",
    totalMemories: "総メモリ数",
    totalMatches: "総マッチ数",
    uniquePlayers: "ユニークプレイヤー",
    topPlayers: "トッププレイヤー",
    recentMatches: "最近のマッチ",
    resetPlayerMemory: "プレイヤーメモリをリセット",
    resetAllMemories: "すべてのメモリをリセット",
    noMemoriesYet: "まだメモリが記録されていません",
    announcements: "お知らせ",
    players: "プレイヤー",
    dashboard: "ダッシュボード",
    config: "設定",
  },
  
  legal: {
    // Common
    back: "戻る",
    lastUpdated: "最終更新日",
    contactUs: "お問い合わせ",
    generalSupport: "一般サポート",
    privacyEmail: "プライバシーメール",
    companyInfo: "NAgentes Tecnologia LTDA • CNPJ: XX.XXX.XXX/0001-XX • ブラジル",
    legalQuestions: "法的な質問",
    introduction: "はじめに",
    
    // Terms of Use page
    termsTitle: "利用規約",
    termsSubtitle: "公正で楽しい体験のためのルール",
    termsHeroTitle: "ゲームルール",
    termsHeroDesc: "Rocketanksの利用規約。",
    termsSummary: "まとめ",
    termsSummaryDesc: "知っておくべきこと",
    
    // Terms intro
    termsWelcome: "Rocketanksへようこそ！",
    termsWelcomeDesc: "アカウントを作成するか、Rocketanksを使用することで、これらの利用規約に同意したことになります。注意してお読みください。いずれかの条項に同意しない場合は、当社のサービスを使用しないでください。",
    termsAgeTitle: "年齢制限",
    termsAgeDesc: "Rocketanksは10歳以上を対象としています。18歳未満のプレイヤーは、プレイするために親または法定後見人の同意が必要です。アプリ内購入には責任ある大人の承認が必要です。",
    
    // Terms sections titles
    termsLicense: "使用ライセンス",
    termsAccount: "あなたのアカウント",
    termsConduct: "行動規範",
    termsPurchases: "購入と仮想通貨",
    termsIntellectual: "知的財産",
    termsAvailability: "サービスの可用性",
    termsLiability: "責任の制限",
    termsPenalties: "違反とペナルティ",
    termsChanges: "規約の変更",
    termsLaw: "適用法",
    
    // Terms License content
    termsLicenseDesc: "これらの規約に従ってRocketanksを使用するための、限定的、個人的、非独占的、譲渡不可、取り消し可能なライセンスを付与します。",
    termsYouCan: "できること：",
    termsYouCanPlay: "個人的な娯楽のためにプレイする",
    termsYouCanPurchase: "体験を向上させるためにアプリ内購入を行う",
    termsYouCanCreate: "ゲームコンテンツを作成・共有する（配信、動画）",
    termsYouCanParticipate: "コミュニティとイベントに参加する",
    termsYouCannot: "できないこと：",
    termsYouCannotModify: "改変、ハッキング、リバースエンジニアリング",
    termsYouCannotSell: "ゲーム外で仮想アイテムを販売または取引する",
    termsYouCannotMultiple: "優位性を得るために複数のアカウントを作成する",
    termsYouCannotBots: "ボット、チート、サードパーティソフトウェアを使用する",
    
    // Terms Account content
    termsAccountDesc: "アカウントのセキュリティを維持し、アカウントで実行されるすべての活動について責任を負います。",
    termsAccountSecurity: "セキュリティ",
    termsAccountSecurityShare: "アカウントを共有しないでください",
    termsAccountSecurityAuth: "安全な認証を使用してください",
    termsAccountSecurityReport: "不審なアクセスを報告してください",
    termsAccountName: "あなたの名前",
    termsAccountNameRespect: "エイリアスでは礼儀正しく",
    termsAccountNameOffensive: "攻撃的または不適切な内容は禁止",
    termsAccountNameChange: "不適切な名前は変更する場合があります",
    termsAccountWarning: "これらの規約に違反するアカウントを停止する権利を留保します。",
    
    // Terms Conduct content
    termsCondictDesc: "健全なコミュニティを維持するため、すべての人に以下のルールに従うことを期待します：",
    termsRespectPlayers: "他のプレイヤーを尊重する",
    termsRespectPlayersDesc: "チャットや試合中は礼儀正しく",
    termsPlayFair: "フェアプレイ",
    termsPlayFairDesc: "エクスプロイト、バグ、チートを使用しない",
    termsReportViolations: "違反を報告する",
    termsReportViolationsDesc: "コミュニティの安全を守る手助けをする",
    termsNoToxicity: "毒性禁止",
    termsNoToxicityDesc: "嫌がらせ、ヘイトスピーチ、いじめ = BAN",
    termsNoSpam: "スパム禁止",
    termsNoSpamDesc: "広告や連続投稿は許可されていません",
    
    // Terms Purchases content
    termsCurrencies: "クリスタルとチップ",
    termsCurrenciesDesc: "ゲーム内でアイテムを取得するために使用される仮想通貨です。実際の金銭的価値はなく、お金と交換することはできません。",
    termsPurchasesFinal: "すべての購入は最終的であり、法律で義務付けられている場合を除き返金不可です",
    termsPricesChange: "価格はいつでも変更される可能性があります",
    termsVirtualItems: "仮想アイテムはNAgentesに帰属し、あなたにライセンスされています",
    termsNoRefundShutdown: "ゲーム終了時、未使用の通貨は返金されません",
    termsConsumerProtection: "消費者保護：",
    termsConsumerProtectionDesc: "18歳未満のプレイヤーは購入に保護者の承認が必要です。支出を制限する保護者管理機能を提供しています。",
    
    // Terms Intellectual content
    termsIntellectualDesc: "Rocketanks（すべてのグラフィックス、音楽、コード、キャラクター、名前、デザインを含む）はNAgentes Tecnologiaの財産です。",
    termsContentCreation: "コンテンツ作成：",
    termsContentCreationDesc: "以下の条件を満たす限り、Rocketanksについて動画、配信、コンテンツを作成できます：",
    termsContentNotOfficial: "公式コンテンツであると主張しない",
    termsContentNotMonetize: "消費者を欺くような方法で収益化しない",
    termsContentCredit: "オリジナルゲームにクレジットを与える",
    
    // Terms Availability content
    termsAvailabilityDesc: "Rocketanksを常に利用可能に保つよう努めていますが、中断のない可用性を保証するものではありません。",
    termsMaintenanceNotice: "メンテナンスは事前通知の有無にかかわらず発生する可能性があります",
    termsServiceModify: "サービスはいつでも変更または終了される可能性があります",
    termsProgressLoss: "不可抗力の場合の進行状況の損失について責任を負いません",
    
    // Terms Liability content
    termsLiabilityDesc: "Rocketanksは「現状のまま」で提供されます。法律で許可される範囲内で：",
    termsNoBugGuarantee: "ゲームがバグやエラーがないことを保証しません",
    termsNoIndirectDamage: "間接的または結果的損害について責任を負いません",
    termsMaxLiability: "最大責任は過去12ヶ月に支払われた金額に制限されます",
    termsLiabilityImportant: "重要：",
    termsLiabilityImportantDesc: "これらの制限は、法律で制限または除外できない権利には影響しません。",
    
    // Terms Penalties content
    termsPenaltiesDesc: "これらの規約に違反すると、以下の結果になる可能性があります：",
    termsWarning: "警告",
    termsWarningDesc: "最初の軽微な違反",
    termsSuspension: "停止",
    termsSuspensionDesc: "一時的（1〜30日）",
    termsBan: "BAN",
    termsBanDesc: "返金なしで永久",
    termsPenaltiesSeverity: "厳格さは違反の性質と頻度によって異なります。決定は当社の裁量で行われます。",
    
    // Terms Changes content
    termsChangesDesc: "これらの規約は定期的に更新される場合があります。重大な変更を行う場合：",
    termsChangesNotify: "メールまたはアプリ内で通知します",
    termsChangesDate: "「最終更新日」が変更されます",
    termsChangesAccept: "ゲームの使用を継続することは、新しい規約に同意したことを意味します",
    
    // Terms Law content
    termsLawDesc: "これらの規約はブラジル連邦共和国の法律に準拠します。",
    termsLawCourt: "紛争はサンパウロ市の管轄裁判所で解決されます。",
    termsFriendlyResolution: "友好的解決：",
    termsFriendlyResolutionDesc: "法的措置の前に、まずお問い合わせください。多くの問題は迅速かつ友好的に解決できます。",
    
    // Terms Summary content
    termsSummaryPlay: "楽しもう - Rocketanksは娯楽のためです！",
    termsSummaryBeNice: "親切に - 他のプレイヤーを尊重する",
    termsSummaryPlayFair: "フェアプレイ - チートやハックは禁止",
    termsSummaryFinal: "購入は最終的 - 購入前に考えて",
    termsSummaryContact: "お問い合わせ - サポートします",
    
    // Privacy Policy page
    privacyTitle: "プライバシーポリシー",
    privacySubtitle: "データの保護方法",
    privacyHeroTitle: "あなたのプライバシーは重要です",
    privacyHeroDesc: "Rocketanksでのデータの取り扱いを明確に説明します。",
    
    // Privacy intro
    privacyIntro: "はじめに",
    privacyIntroDesc: "Rocketanksの開発者であるNAgentes Tecnologiaは、あなたのプライバシーを保護することに取り組んでいます。このポリシーでは、収集する情報、使用方法、および個人データに関するあなたの権利について説明します。",
    
    // Privacy sections titles
    privacyCollection: "収集するデータ",
    privacyUsage: "データの使用方法",
    privacySecurity: "データセキュリティ",
    privacyRights: "あなたの権利（LGPD）",
    privacyCookies: "Cookieとローカルストレージ",
    privacyMinors: "未成年者の保護",
    privacyChanges: "ポリシーの変更",
    
    // Privacy Collection content
    privacyAccountData: "アカウントデータ",
    privacyAccountEmail: "メール（ログインと通信用）",
    privacyAccountUsername: "ユーザー名（公開エイリアス）",
    privacyAccountBirth: "生年月日（年齢確認用）",
    privacyAccountAvatar: "選択したアバター",
    privacyGameData: "ゲームデータ",
    privacyGameProgress: "ゲームの進行状況（戦車、レベル、通貨）",
    privacyGameStats: "試合統計（勝利、敗北、スコア）",
    privacyGameSettings: "設定の好み",
    privacyGamePurchases: "アプリ内購入履歴",
    privacyTechData: "技術データ",
    privacyTechDevice: "デバイスの種類とオペレーティングシステム",
    privacyTechIP: "IPアドレス（セキュリティ用）",
    privacyTechLogs: "エラーと診断ログ",
    
    // Privacy Usage content
    privacyUsageImprove: "ゲーム体験を提供し改善する",
    privacyUsageSave: "クラウドに進行状況を保存する",
    privacyUsagePayments: "支払いと購入を処理する",
    privacyUsageNotify: "アカウントに関する重要な通知を送信する",
    privacyUsageFraud: "詐欺と不正使用を防止する",
    privacyUsageMatchmaking: "マッチメイキングとバランスを改善する",
    privacyNeverSell: "データを第三者に販売することはありません",
    privacyNeverShare: "メールを広告主と共有することはありません",
    
    // Privacy Security content
    privacySecurityDesc: "データを保護するためにエンタープライズレベルのセキュリティ対策を実施しています：",
    privacySecurityTLS: "TLS/SSL暗号化",
    privacySecurityTLSDesc: "転送中のすべてのデータは暗号化されています",
    privacySecurityDB: "安全なデータベース",
    privacySecurityDBDesc: "保存時暗号化でデータを保存",
    privacySecurityTokens: "安全なトークン",
    privacySecurityTokensDesc: "OAuth2とJWTによる認証",
    privacySecurityMonitor: "監視",
    privacySecurityMonitorDesc: "24時間365日の不審なアクセス検出",
    
    // LGPD Rights (Brazil)
    lgpdRights: "一般データ保護法（LGPD）に基づき、以下の権利があります：",
    lgpdAccess: "アクセス",
    lgpdAccessDesc: "あなたに関するデータを知る",
    lgpdCorrection: "訂正",
    lgpdCorrectionDesc: "不正確または不完全なデータを訂正する",
    lgpdDeletion: "削除",
    lgpdDeletionDesc: "データの削除を要求する",
    lgpdPortability: "ポータビリティ",
    lgpdPortabilityDesc: "読み取り可能な形式でデータを受け取る",
    lgpdRevocation: "撤回",
    lgpdRevocationDesc: "いつでも同意を撤回する",
    lgpdExercise: "権利を行使するには：",
    
    // Privacy Cookies content
    privacyCookiesDesc: "ローカルストレージ（localStorage）を以下の目的で使用しています：",
    privacyCookiesLogin: "セッション間でログイン状態を維持する",
    privacyCookiesSettings: "設定の好みを保存する",
    privacyCookiesCache: "ゲームリソースのキャッシュを保存する",
    privacyCookiesNoTracking: "ターゲット広告のためのサードパーティトラッキングCookieは使用していません。",
    
    // Privacy Minors content
    privacyMinorsAge: "Rocketanksは10歳以上を対象としています。",
    privacyMinorsImportant: "重要：",
    privacyMinorsConsent: "18歳未満のプレイヤーは保護者の同意が必要です",
    privacyMinorsNoCollect: "13歳未満のユーザーからデータを意図的に収集しません",
    privacyMinorsPurchases: "アプリ内購入には保護者の承認が必要です",
    
    // Privacy Changes content
    privacyChangesDesc: "このポリシーは定期的に更新される場合があります。重大な変更を行う場合：",
    privacyChangesNotify: "メールまたはアプリ内で通知します",
    privacyChangesDate: "「最終更新日」が変更されます",
    privacyChangesEffective: "変更は公開後30日で有効になります",
  },

  infinite: {
    bestWave: "自己ベスト",
    newRecord: "新記録！",
    noRecordYet: "記録なし",
    medals: "メダル",
    nextMedal: "次のメダル：ウェーブ{wave}",
    statusBurning: "炎上中",
    statusSoaked: "ずぶ濡れ",
    statusMuddy: "泥まみれ",
    statusHint: "水は火を消す",
    contract: "ウェーブ課題",
    contractComplete: "課題達成！",
    contractFailed: "課題失敗",
    contractReward: "ボーナス",
    chooseUpgrade: "強化を選ぼう",
    chooseUpgradeHint: "この走行の最後まで有効",
    reroll: "カードを引き直す",
    rerollsLeft: "残り{count}回",
    skipDraft: "スキップ",
    yourBuild: "あなたの戦車",
    waveLabel: "ウェーブ{wave}",
    bossWaveIn: "あと{count}でボス",
    bossWaveNow: "ボス",
    eliteWave: "エリート",
    hazardWarning: "注意",
    tapToSkip: "タップでスキップ",
    runSummary: "走行の記録",
    contractsCleared: "達成した課題",

    cards: {
      twin_barrel: { title: "連装砲身", description: "1発追加、ただし1発ごとの威力は少し低下" },
      heavy_shell: { title: "重装弾", description: "ダメージ+18%" },
      piercing_round: { title: "貫通弾", description: "弾が敵をもう1体貫く" },
      hot_powder: { title: "高温火薬", description: "弾速+25% — 当てやすくなる" },
      siege_cannon: { title: "攻城砲", description: "ダメージ+55%、ただし弾速は低下" },
      reinforced_hull: { title: "強化装甲", description: "最大HP+25" },
      composite_armor: { title: "複合装甲", description: "受けるダメージを18%吸収" },
      heavy_plating: { title: "重装甲板", description: "ダメージを32%吸収しHP+40、ただし鈍重になる" },
      field_repair: { title: "野戦修理", description: "各ウェーブ終了時に+18回復" },
      race_treads: { title: "レース履帯", description: "速度+12%" },
      amphibious_kit: { title: "水陸両用キット", description: "水と泥でほとんど減速しない" },
      studded_treads: { title: "スパイク履帯", description: "氷の上で滑らなくなる" },
      heat_shield: { title: "耐熱シールド", description: "溶岩のダメージが大幅に減少" },
      all_terrain: { title: "全地形対応", description: "水・氷・溶岩をほとんど気にしなくなる" },
      item_magnet: { title: "アイテム磁石", description: "近くのアイテムが寄ってくる" },
      strong_magnet: { title: "強力磁石", description: "はるか遠くのアイテムも引き寄せる" },
      scavenger: { title: "回収者", description: "敵を倒すごとにHP+4" },
      second_thought: { title: "考え直し", description: "カードの引き直し+1回" },
      glass_cannon: { title: "ガラスの大砲", description: "ダメージ+60%、ただし最大HP−35" },
      reckless_charge: { title: "無謀な突撃", description: "速度+30%、ただし最大HP−20" },
      overload: { title: "オーバーロード", description: "ダメージ+35%と弾+2、ただしHP−25" },
      vampire_core: { title: "吸血コア", description: "撃破ごとにHP+10、ダメージは少し低下" },
      bulwark: { title: "防塁", description: "HP+90と追加回復、ただし鈍重" },
      storm_of_lead: { title: "鉛の嵐", description: "1斉射で+3発、ただし1発ごとは弱い" },
    },

    contracts: {
      no_damage: { title: "無傷", description: "ダメージを受けずにウェーブを終える" },
      no_items: { title: "腕だけで", description: "アイテムを使わずにウェーブを終える" },
      speedrun: { title: "電光石火", description: "{target}秒以内にウェーブを制圧" },
      combo: { title: "連続撃破", description: "6秒以内に{target}体撃破" },
      priority_target: { title: "指定目標", description: "他より先に{target}を破壊" },
      demolisher: { title: "解体屋", description: "ブロックを{target}個破壊" },
      long_range: { title: "遠距離射撃", description: "遠くから{target}体撃破" },
      close_quarters: { title: "至近距離", description: "近距離で{target}体撃破" },
      full_health: { title: "無傷", description: "HP{target}%以上でウェーブを終える" },
      firewalker: { title: "火渡り", description: "炎上中に{target}体撃破" },
    },

    enemyKinds: {
      normal: "兵士",
      heavy: "重装甲",
      fast: "高速",
      sniper: "狙撃兵",
      boss: "指揮官",
    },

    archetypes: {
      open: "開けた戦場",
      lake: "裂けた湖",
      marsh: "湿地",
      glacier: "割れた氷河",
      archipelago: "群島",
      forge: "溶鉱炉",
      crater: "火口",
    },

    worldModifiers: {
      none: { title: "", description: "" },
      swarm: { title: "群れ", description: "敵が多いが、どれも脆い" },
      juggernaut: { title: "巨兵", description: "敵は少ないが、非常に硬い" },
      sharpshooter: { title: "狙撃兵", description: "そこら中にスナイパー" },
      blitz: { title: "電撃戦", description: "全員が高速化" },
      volatile: { title: "爆発性", description: "敵は死ぬと爆発する" },
    },

    hazards: {
      water: "水 — 動きが遅くなる",
      lava: "溶岩 — 燃える！",
      ice: "氷 — 滑る",
      mud: "泥 — はまり込む",
    },
  },
  sofa: {
    menuTitle: "ソファモード",
    menuDesc: "スマホ、PC、テレビの1画面で最大4人。コントローラーでもキーボードでもOK。空き枠はCPU。",
    title: "ソファモード",
    subtitle: "1画面で最大4人：スマホ、PC、テレビ",
    player: "プレイヤー{n}",
    keyboardJoin: "またはキーボードの{key}",
    joined: "準備完了",
    leaveHint: "Bで退出",
    modeCoop: "協力",
    modeCoopDesc: "みんなでボットのウェーブに挑む。各3ライフ、倒れてもウェーブ終了で復活。",
    modeVersus: "対決",
    modeVersusDesc: "全員で対戦。先に{kills}キルした人の勝ち。",
    arena: "アリーナ",
    back: "戻る",
    tvTitle: "テレビで遊ぶ（任意）",
    tvStep1: "ゲームを動かす端末にコントローラーをペアリング（最大4台）。PCならキーボードも使えます。",
    tvStep2: "テレビに映す：iPhoneはAirPlay、AndroidはSmart View、PCはHDMIケーブル。",
    tvStep3: "遅延を減らすためテレビのゲームモードをオンに。スマホは横向きで。",
    noGamepadApi: "このブラウザはコントローラーを読み取れません。キーボードか別のブラウザを使ってください。",
    keyboardWasd: "キーボード：WASD＋スペース",
    keyboardArrows: "キーボード：矢印＋Enter",
    wave: "ウェーブ{n}",
    firstTo: "先取{n}",
    getReady: "準備",
    go: "戦え！",
    waveCleared: "ウェーブ{n}クリア！",
    nextWaveIn: "次のウェーブまで{n}",
    respawnIn: "復帰まで{n}",
    paused: "一時停止",
    quit: "終了",
    pauseHint: "十字キーで選択 · Aで決定 · BまたはStartで再開",
    disconnected: "プレイヤー{n}のコントローラーが切断されました",
    reconnectHint: "コントローラーをオンにしてAを押す",
    victory: "{name}の勝ち！",
    reachedWave: "ウェーブ{n}まで到達",
    rematch: "再戦",
    overHint: "十字キーで選択 · Aで決定 · Bでロビーへ",
    lives: "ライフ",
    modeRivals: "ライバル",
    modeRivalsDesc: "同じウェーブだが、撃破ごとに撃った人にポイント。{waves}ウェーブ後、高得点の方の勝ち。",
    difficulty: "難易度",
    diffEasy: "イージー",
    diffNormal: "ノーマル",
    diffHard: "ハード",
    killsLabel: "勝利に必要なキル",
    noSpecial: "パワーなし",
    score: "{n}点",
    waitingRescue: "脱落！パートナーが救助できます",
    rescuing: "救助中… {n}%",
    annKilled: "{a}が{b}を撃破！",
    annDown: "{name}がやられた！",
    annEliminated: "{name}が脱落 — 救助に行け！",
    annRescued: "{a}が{b}を救助！",
    annBoss: "ボス出現！",
    annBossDown: "ボス撃破！",
    annPickup: "{name}：{item}",
    hintPad: "左スティックで移動 · 右スティックで照準 · RT/Aで射撃（長押しでチャージ）· LB/Xでアイテム",
    hintWasd: "WASDで移動 · スペースで射撃（長押しでチャージ）· E/Qでアイテム",
    hintArrows: "矢印で移動 · Enterで射撃（長押しでチャージ）· 右Shiftでアイテム",
    accuracy: "命中率",
    damage: "ダメージ",
    reward: "+{n}チップ",
    newRecord: "新記録！",
    draw: "引き分け！",
    stepJoin: "プレイヤー",
    stepTanks: "戦車",
    stepSetup: "対戦",
    stepOf: "ステップ {n}/{total}",
    joinTitle: "誰が遊ぶ？",
    joinText: "台数を選んでください。コントローラーのA（キーボードはSpace/Enter）を押した人が参加し、残りの枠はCPUになります。",
    continue: "次へ",
    continueHint: "AかStartで戦車選択へ",
    confirmTank: "決定（{key}）",
    tanksTitle: "戦車を選ぼう",
    tanksText: "自分のトークンを戦車に移動して決定。CPUはランダムに選びます。",
    tanksPadHint: "十字キーで選択 · LB/RB パワー · A 決定 · B 戻る",
    tanksKeysHint: "キーボード：WASD・Q/E・Space ／ 矢印・[ ]・Enter",
    killsShort: "{n}キル",
    setupTitle: "対戦の設定",
    setupText: "モード・難易度・アリーナ。どのプレイヤーでも選べます。",
    modeLabel: "モード",
    startMatch: "対戦開始",
    setupHint: "▲ ▼ 選択 · ◀ ▶ 変更 · A 決定 · Start 開始 · B 戻る",
    leave: "退出",
    prevPower: "前のパワー",
    nextPower: "次のパワー",
    pairTitle: "コントローラーのペアリング",
    pairWhereIos: "iPhoneでは「設定」→「Bluetooth」を開き、「その他のデバイス」からコントローラー名をタップします。",
    pairWhereAndroid: "Androidでは「設定」→「Bluetooth」（または「接続済みのデバイス」）→「新しいデバイスとペア設定」を開き、コントローラー名をタップします。",
    pairWhereDesktop: "パソコンではBluetooth設定を開き、デバイスを追加してコントローラーを選びます。",
    pairBrandOther: "その他",
    pairXbox: "Xboxボタンで電源を入れ、上部（USB端子の横）のペアリングボタンをXboxロゴが速く点滅するまで長押しします。",
    pairPlaystation: "CreateとPSを同時に長押し（PS4はSHAREとPS）し、ライトが速く点滅するまで待ちます。",
    pairNintendo: "Proコントローラー：上部（USB端子の横）のシンクロボタンを長押し。Joy-Con：側面のシンクロボタンをランプが流れるまで長押しします。",
    pairOther: "ペアリングモードの入り方は説明書を確認してください。8BitDo：X（Xbox）またはS（Switch）モードで電源を入れ、ペアボタンを長押しします。",
    pairThen: "ゲームに戻り、コントローラーのAを押して参加します。",
    pairNote: "ペアリングはシステムで行い、コントローラーごとに一度だけです。ゲームが自分でペアリングすることはできません。その後は電源を入れるだけです。",
    diagTitle: "診断",
    diagHint: "各コントローラーのボタンを押してください。すべてここに表示されるはずです。iPhoneでは最初のボタン操作後に表示されます。",
    diagApiOk: "このブラウザはコントローラーを認識できます",
    diagNoPads: "まだコントローラーが見つかりません。各コントローラーのボタンを押してください。",
    diagStandard: "標準マッピング",
    diagNonStandard: "非標準マッピング",
    diagRumble: "振動",
    diagButtons: "ボタン",
    diagShowFps: "対戦中にFPSを表示",
    cpuName: "CPU {n}",
    map: "マップ",
    slotHuman: "プレイヤー",
    slotOff: "空き",
    slotTakeHint: "Aで参加",
    slotClickHint: "クリックでキーボード参加",
    keyboardPlay: "キーボードで遊ぶ",
    keyboardPlayHint: "ここをクリックかSpace・コントローラーはA",
    slotAdd: "枠を追加",
    playersLabel: "プレイヤー数",
    cpuLevel: "CPUレベル",
    needHuman: "コントローラーのAを押して参加",
    summaryPlayers: "{n}台",
    summaryCpu: "CPU {n}台",
    playersPadHint: "A 参加 · B 退出 · X/Y 枠の増減 · Start 次へ",
    playersKeysHint: "キーボード（1台で2人まで）：Space（P1）、Enter（P2）、2・3・4で人数",
    shuffle: "ランダム",
    readyToFight: "バトル準備完了！",
    readyToFightHint: "AかStartで次へ",
  },
};

export default ja;
